export function withCapability(enabled, Component) {
    if (enabled)
        return Component;
    return function DisabledCapability() {
        return null;
    };
}
//# sourceMappingURL=CapabilityGate.js.map